/* -----------------Globals--------------- */
import { pageViewTypes } from "@constants/tracking";

/* -----------------Child components--------------- */
import SessionContainer from "@features/session/screens/Session";

/* -----------------Helpers & Hooks--------------- */
import useAnalytics from "@hooks/useAnalytics";
import DocumentTitle from "components/DocumentTitle";

import { useAilaStore } from "@features/session/hooks/useAilaStore";
/* -----------------UI--------------- */
import { Stack } from "expo-router";
import { useEffect, useMemo } from "react";

const ReviewRoute = () => {
	const updateShowDrawer = useAilaStore((state) => state.updateShowDrawer);
	useEffect(() => {
		return () => {
			updateShowDrawer(false);
		};
	}, [updateShowDrawer]);
	const memoizedAnalyticsParams = useMemo(() => {
		return {
			type: pageViewTypes.review,
		};
	}, []);
	useAnalytics(memoizedAnalyticsParams);

	return (
		<>
			<Stack.Screen
				options={{
					headerShown: false,
				}}
			/>
			<DocumentTitle title={"Review"} />
			<SessionContainer />
		</>
	);
};

export default ReviewRoute;
